import "primeicons/primeicons.css";
import "src/style.css";
import "src/flags.css";
import "src/vueform.css";
import router from "./router";
import Vueform from "@vueform/vueform";
import vueformConfig from "../vueform.config";
import { App as CapacitorApp } from "@capacitor/app";
import { Keyboard } from "@capacitor/keyboard";
import { Capacitor } from "@capacitor/core";

import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import DialogService from "primevue/dialogservice";
import DynamicDialog from "primevue/dynamicdialog";
import ToastService from "primevue/toastservice";
import ProgressSpinner from "primevue/progressspinner";
import ProgressBar from "primevue/progressbar";

import Vue3Signature from "vue3-signature";

import Quill from "quill";

// Camera
import Camera from "simple-vue-camera";

import App from "src/App.vue";
import AppState from "src/plugins/appState.js";
import Aura from "@primevue/themes/aura";
// directive
import Tooltip from "primevue/tooltip";
import Ripple from "primevue/ripple";
// components
import Knob from "primevue/knob";
import AutoComplete from "primevue/autocomplete";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import Chip from "primevue/chip";
import Breadcrumb from "primevue/breadcrumb";
import Drawer from "primevue/drawer";
import Card from "primevue/card";
import Button from "primevue/button";
import ButtonGroup from "primevue/buttongroup";
import Badge from "primevue/badge";
import InputText from "primevue/inputtext";
import Avatar from "primevue/avatar";
import Menubar from "primevue/menubar";
import TieredMenu from "primevue/tieredmenu";
import ConfirmDialog from "primevue/confirmdialog";
import DataTable from "primevue/datatable";
import Toolbar from "primevue/toolbar";
import Dialog from "primevue/dialog";
import Toast from "primevue/toast";
import FileUpload from "primevue/fileupload";
import InputIcon from "primevue/inputicon";
import IconField from "primevue/iconfield";
import Column from "primevue/column";
import ColumnGroup from "primevue/columngroup";
import Row from "primevue/row";
import Rating from "primevue/rating";
import Tag from "primevue/tag";
import Textarea from "primevue/textarea";
import Select from "primevue/select";
import MultiSelect from "primevue/multiselect";
import RadioButton from "primevue/radiobutton";
import InputNumber from "primevue/inputnumber";
import Skeleton from "primevue/skeleton";
import SelectButton from "primevue/selectbutton";
import DataView from "primevue/dataview";
import DatePicker from "primevue/datepicker";
import Message from "primevue/message";
import ToggleSwitch from "primevue/toggleswitch";
import Stepper from "primevue/stepper";
import StepPanels from "primevue/steppanels";
import StepPanel from "primevue/steppanel";
import StepList from "primevue/steplist";
import Step from "primevue/step";
import FloatLabel from "primevue/floatlabel";
import Menu from "primevue/menu";
import OverlayBadge from "primevue/overlaybadge";
import Tab from "primevue/tab";
import Tabs from "primevue/tabs";
import TabList from "primevue/tablist";
import TabPanel from "primevue/tabpanel";
import TabPanels from "primevue/tabpanels";
import TreeTable from "primevue/treetable";
import VirtualScroller from "primevue/virtualscroller";
import Divider from "primevue/divider";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import AccordionPanel from "primevue/accordionpanel";
import AccordionHeader from "primevue/accordionheader";
import AccordionContent from "primevue/accordioncontent";
import { definePreset } from "@primevue/themes";
import Editor from "primevue/editor";
import "vue-pdf-embed/dist/styles/annotationLayer.css";
import "vue-pdf-embed/dist/styles/textLayer.css";
import VuePdfEmbed from "vue-pdf-embed";
import InputChips from "primevue/inputchips";
import Checkbox from "primevue/checkbox";
import KeyFilter from "primevue/keyfilter";
import auth from "./utils/auth";
import { UseImage } from "@vueuse/components/index.cjs";
import FormTemplatePage from "src/pages/admin/formTemplate/FormTemplatePage.vue";
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import FormLabelComponent from "@/components/FormLabelComponent.vue";
import PageBuilderComponent from "@/components/PageBuilderComponent.vue";
import ErrorDialog from "@/components/ErrorDialog.vue";
import ProceduresTemplateComponent from "@/pages/admin/formTemplate/components/ProceduresTemplateComponent.vue";
import { Tree } from "primevue";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
export const app = createApp(App);

//-------- Settings for Auto Zoom-In in IOS

// Capacitor Keyboard Plugin Setup
const platform = Capacitor.getPlatform();
if (platform === "ios") {
  Keyboard.setScroll({ isDisabled: false });
  // Optional: Set accessory bar visibility (iOS only) // will show done btn when writing on inputs
  Keyboard.setAccessoryBarVisible({ isVisible: true });
}

// ------ Settings for Auto Zoom-In in IOS Done

app.use(pinia);
// init router
app.use(router);

// re-setting setting of rxDB store

app.use(Vueform, vueformConfig);

const _Aura = definePreset(Aura, {
  semantic: {
    primary: {
      50: "{orange.50}",
      100: "{orange.100}",
      200: "{orange.200}",
      300: "{orange.300}",
      400: "{orange.400}",
      500: "#F98023",
      600: "{orange.600}",
      700: "{orange.700}",
      800: "#ce4112",
      900: "{orange.900}",
      950: "{orange.950}"
    },
    colorScheme: {
      light: {
        primary: {
          color: "#F98023",
          inverseColor: "#ffffff",
          hoverColor: "{orange.900}",
          activeColor: "#ce4112"
        },
        highlight: {
          background: "{orange.950}",
          focusBackground: "{orange.700}",
          color: "#ffffff",
          focusColor: "#ffffff"
        }
      }
    }
  }
});

app.use(PrimeVue, {
  theme: {
    preset: _Aura,
    options: {
      darkModeSelector: ".fake-dark-selector" // Forcing light mode by adding fake dark mode classes
    }
  },
  zIndex: {
    modal: 1100,
    overlay: 1200,
    menu: 1300,
    tooltip: 1400,
    toast: 1500
  }
});
app.use(AppState);
app.use(ConfirmationService);
app.use(ToastService);
app.use(DialogService);
app.use(Vue3Signature);
app.component("Camera", Camera);
app.directive("tooltip", Tooltip);
app.directive("ripple", Ripple);
app.directive("keyfilter", KeyFilter);

app.component("Badge", Badge);
app.component("InputText", InputText);
app.component("Avatar", Avatar);
app.component("Menubar", Menubar);
app.component("Drawer", Drawer);
app.component("Card", Card);
app.component("Button", Button);
app.component("ButtonGroup", ButtonGroup);
app.component("ProgressSpinner", ProgressSpinner);
app.component("ProgressBar", ProgressBar);
app.component("TieredMenu", TieredMenu);
app.component("ConfirmDialog", ConfirmDialog);
app.component("DataTable", DataTable);
app.component("Toolbar", Toolbar);
app.component("Dialog", Dialog);
app.component("DynamicDialog", DynamicDialog);

app.component("Toast", Toast);
app.component("FileUpload", FileUpload);
app.component("InputIcon", InputIcon);
app.component("IconField", IconField);
app.component("Column", Column);
app.component("ColumnGroup", ColumnGroup);
app.component("Row", Row);
app.component("Rating", Rating);
app.component("Tag", Tag);
app.component("Textarea", Textarea);
app.component("Select", Select);
app.component("MultiSelect", MultiSelect);
app.component("RadioButton", RadioButton);
app.component("InputNumber", InputNumber);
app.component("Skeleton", Skeleton);
app.component("SelectButton", SelectButton);
app.component("DataView", DataView);
app.component("DatePicker", DatePicker);
app.component("Message", Message);
app.component("ToggleSwitch", ToggleSwitch);
app.component("Stepper", Stepper);
app.component("StepPanels", StepPanels);
app.component("StepPanel", StepPanel);
app.component("StepList", StepList);
app.component("Step", Step);
app.component("FloatLabel", FloatLabel);
app.component("Menu", Menu);
app.component("Tab", Tab);
app.component("Tabs", Tabs);
app.component("TabList", TabList);
app.component("TabPanel", TabPanel);
app.component("TabPanels", TabPanels);
app.component("OverlayBadge", OverlayBadge);
app.component("VirtualScroller", VirtualScroller);
app.component("Divider", Divider);
app.component("VuePdfEmbed", VuePdfEmbed);
app.component("InputChips", InputChips);
app.component("Checkbox", Checkbox);
app.component("Editor", Editor);
app.component("UseImage", UseImage);
app.component("Knob", Knob);
app.component("AutoComplete", AutoComplete);
app.component("InputGroup", InputGroup);
app.component("InputGroupAddon", InputGroupAddon);
app.component("Chip", Chip);
app.component("Breadcrumb", Breadcrumb);
app.component("Accordion", Accordion);
app.component("AccordionTab", AccordionTab);
app.component("AccordionPanel", AccordionPanel);
app.component("AccordionHeader", AccordionHeader);
app.component("AccordionContent", AccordionContent);
app.component("FormTemplatePage", FormTemplatePage);
app.component("ConfirmationDialog", ConfirmationDialog);
app.component("FormLabelComponent", FormLabelComponent);
app.component("PageBuilderComponent", PageBuilderComponent);
app.component("ErrorDialog", ErrorDialog);
app.component("ProceduresTemplateComponent", ProceduresTemplateComponent);
app.component("TreeTable", TreeTable);

Quill.register(Quill.import("attributors/style/align"), true);
Quill.register(Quill.import("attributors/style/size"), true);
Quill.register(Quill.import("attributors/style/font"), true);

// app.config.performance = true;

// Initialize permissions before mounting the app
async function initializeApp() {
  try {
    // Check if user is authenticated before setting permissions
    const isAuthenticated = await auth.isUserSignedIn();

    if (isAuthenticated) {
      // Import and initialize permissions store
      const { usePermissionsStore } = await import("@/stores/permissionsStore");
      const permissionsStore = usePermissionsStore();

      // Set permissions before app renders
      await permissionsStore.setPermissions();
      console.log("Permissions initialized before app render");
    }
  } catch (error) {
    console.error("Error initializing permissions:", error);
    // Continue with app initialization even if permissions fail
  }

  // Mount the app after permissions are set
  app.mount("#app");
}

// Initialize app with permissions
initializeApp();

// Event listeners for detecting changes in network status
window.addEventListener("online", async () => {
  console.log("User came online");
  await auth.isUserSignedIn();
});

window.addEventListener("offline", () => {
  console.log("User went offline");
  auth.isUserSignedIn();
});

// Handle incoming URLs
CapacitorApp.addListener("appUrlOpen", (info) => {
  // info.url will contain the URL that the app was opened with
  const url = new URL(info.url);

  // Extract path and parameters from the URL
  const path = url.pathname;
  const params = new URLSearchParams(url.search);

  // Navigate to the appropriate route based on the path
  if (path === "/authCallback") {
    // Handle authentication callback
    router.push({ path: "/auth-callback", query: { ...params } });
  }
});

// Load Google Maps API dynamically
function loadGoogleMapsAPI() {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve(window.google.maps);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${import.meta.env.VITE_GMAPS_KEY}&libraries=places,marker`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      resolve(window.google.maps);
    };

    script.onerror = () => {
      reject(new Error("Failed to load Google Maps API"));
    };

    document.head.appendChild(script);
  });
}

// Make it available globally
window.loadGoogleMapsAPI = loadGoogleMapsAPI;
